import React from 'react';

// Content shell for a single admin panel rendered inside AdminLayout's right
// column. Unlike PortalPageShell it carries no full-screen background/top padding
// (the layout owns the frame) — it just lays out the section header + content.
export default function AdminSection({
  eyebrow,
  title,
  description,
  actions,
  children,
  widthClassName = 'max-w-7xl',
}) {
  return (
    <div className={`${widthClassName} mx-auto w-full px-5 py-8 md:px-8`}>
      <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div className="max-w-2xl">
          {eyebrow ? (
            <div className="inline-flex items-center rounded-full border border-[#1fa5a3]/20 bg-white px-4 py-1 text-xs font-semibold uppercase tracking-[0.24em] text-[#1fa5a3]">
              {eyebrow}
            </div>
          ) : null}
          <h1 className="mt-3 text-3xl font-bold leading-tight text-[#14213d] md:text-4xl">{title}</h1>
          {description ? <p className="mt-3 text-base leading-relaxed text-slate-600">{description}</p> : null}
        </div>
        {actions ? <div className="flex flex-wrap gap-3">{actions}</div> : null}
      </div>
      {children}
    </div>
  );
}
